import { AbsoluteFill, Sequence } from 'remotion';
import LayerOverlay from '@/components/remotion/LayerOverlay';
import type { MotionScene } from '@/lib/motion/types';

/** One positioned layer shared by the admin Player and headless acceptance renders. */
export const MotionTestComposition = ({ scene, offsetFrames = 0 }: { scene: MotionScene; offsetFrames?: number }) => (
  <AbsoluteFill style={{ background: '#101827' }}>
    <Sequence from={offsetFrames}>
      <LayerOverlay overlay={{
        type: 'motion', scene, start: 0, end: 6,
        layer: { rect: { x: 0, y: 0, w: 1, h: 1 }, rotation: 0, opacity: 1, zIndex: 0 },
      }} />
    </Sequence>
  </AbsoluteFill>
);
